import {
  CHATKIT_ICON_MARKUP,
  CHATKIT_ICON_NAMES,
} from '../generated/chatkit-icon-names';

const ICON_ALIASES: Record<string, string> = {
  broom: 'brush-cleaning',
  close: 'x',
  cross: 'x',
};

const ICON_NAME_LOOKUP = new Map<string, string>();

for (const iconName of CHATKIT_ICON_NAMES) {
  ICON_NAME_LOOKUP.set(iconName, iconName);
  ICON_NAME_LOOKUP.set(iconName.replace(/-/g, ''), iconName);
}

export function normalizeChatKitIconName(name: string | undefined): string {
  return String(name ?? '')
    .trim()
    .replace(/^lucide[:-]/i, '')
    .replace(/^icon-/, '')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .toLowerCase();
}

export function resolveChatKitIconName(
  name: string | undefined
): string | undefined {
  const normalized = normalizeChatKitIconName(name);
  if (!normalized) return undefined;

  const aliased = ICON_ALIASES[normalized] ?? normalized;
  return (
    ICON_NAME_LOOKUP.get(aliased) ??
    ICON_NAME_LOOKUP.get(aliased.replace(/-/g, ''))
  );
}

export function chatKitIconMarkup(name: string | undefined): string | undefined {
  const iconName = resolveChatKitIconName(name);
  if (!iconName) return undefined;

  return CHATKIT_ICON_MARKUP[iconName as keyof typeof CHATKIT_ICON_MARKUP];
}
